import { Helmet } from "react-helmet-async";

/**
 * JsonLd — injects a Schema.org JSON-LD <script> into <head>.
 * Pass either a single object or an array of objects.
 */
export default function JsonLd({ data }) {
  if (!data) return null;
  const payload = Array.isArray(data) ? data : [data];
  return (
    <Helmet>
      {payload.map((d, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(d)}
        </script>
      ))}
    </Helmet>
  );
}
